<template>
  <span>
    <a href="javascript:;" @click.prevent="$bvModal.show(modalId)">
      <i class="fa fa-lg fa-search pr-1"></i>
    </a>
    <b-modal :id="modalId" :title="`Rechazo #${id}`" @show="onShow" @hide="onHide" size="lg">
      <b-spinner v-if="!ready"></b-spinner>
      <div v-if="ready">
        <div>
          <h1>Reporte de rechazo Nº {{ rechazo.id }}</h1>
          <h2>Identificación de la muestra</h2>
          <table style="border-collapse: collapse; width: 100%; border: solid black 2px" cellspacing="0">
            <tbody>
              <tr>
                <th style="border: solid 1px black; text-align: left">Productor</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ rechazo.grower }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Lote(s)</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ rechazo.pallets }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Guía</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ rechazo.waybills }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Variedad(es)</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ rechazo.varieties }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Recipiente</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ rechazo.container }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Cantidad de recipientes</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ rechazo.quantity }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Kilogramos</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ rechazo.kilograms }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Fecha</th>
                <td style="border: solid 1px black; text-align: center">{{ rechazo.date }}</td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Muestra</th>
                <td style="border: solid 1px black; text-align: center">10%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h2>Daños y defectos (%)</h2>
          <table style="border-collapse: collapse; width: 100%; border: solid black 2px" cellspacing="0">
            <tbody>
              <tr>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">INACEPTABLES</th>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">PARÁMETROS</th>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">MUESTRA</th>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Colapsados</th>
                <td style="border: solid 1px black; text-align: center">0%</td>

                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.colapsados > 0 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.colapsados }} %
                </td>
              </tr>

              <tr>
                <th style="border: solid 1px black; text-align: left">Hongos</th>
                <td style="border: solid 1px black; text-align: center">0%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.hongos > 0 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.hongos }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Insectos</th>
                <td style="border: solid 1px black; text-align: center">0%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.insectos > 0 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.insectos }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Tierra</th>
                <td style="border: solid 1px black; text-align: center">0%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.tierra > 0 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.tierra }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">MAYORES</th>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">PARÁMETROS</th>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">MUESTRA</th>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Blandos</th>
                <td style="border: solid 1px black; text-align: center">3%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.blandos > 3 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.blandos }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Semi Blandos</th>
                <td style="border: solid 1px black; text-align: center">8%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.semiBlandos > 8 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.semiBlandos }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Exudación de Jugo</th>
                <td style="border: solid 1px black; text-align: center">1%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.exudacionJugo > 1 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.exudacionJugo }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Verdes</th>
                <td style="border: solid 1px black; text-align: center">2%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.verdes > 2 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.verdes }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Rojizos</th>
                <td style="border: solid 1px black; text-align: center">6%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.rojizos > 6 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.rojizos }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Déficit Bloom</th>
                <td style="border: solid 1px black; text-align: center">8%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.deficitBloom > 8 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.deficitBloom }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Machucones con Jugo</th>
                <td style="border: solid 1px black; text-align: center">1%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.machuconesJugo > 1 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.machuconesJugo }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Deshidratados</th>
                <td style="border: solid 1px black; text-align: center">4%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.deshidratados > 4 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.deshidratados }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">MENORES</th>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">PARÁMETROS</th>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">MUESTRA</th>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Pedicelo</th>
                <td style="border: solid 1px black; text-align: center">8%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.pedicelo > 8 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.pedicelo }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Restos de Flor</th>
                <td style="border: solid 1px black; text-align: center">8%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.restosFlor > 8 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.restosFlor }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Machucones Secos</th>
                <td style="border: solid 1px black; text-align: center">3%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.machuconesSecos > 3 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.machuconesSecos }}%
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Cicatrices/Heridas</th>
                <td style="border: solid 1px black; text-align: center">8%</td>
                <td
                  style="border: solid 1px black; text-align: center"
                  :class="rechazo.defects.cicatricesHeridas > 8 ? 'text-danger' : ''"
                >
                  {{ rechazo.defects.cicatricesHeridas }}%
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>Observaciones</h2>
        <div style="min-height: 150px; border: solid black 1px; margin-bottom: 20px">
          <p>{{ rechazo.observations }}</p>
        </div>
        <div>
          Atte.,<br />
          Departamento de Calidad <br />
          Exportadora Bluefields Chile Ltda.
        </div>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: "ModalDetalleRechazo",
  computed: {
    modalId() {
      return "modal-detalle-rechazo-" + this.id;
    }
  },
  data() {
    return {
      ready: false,
      rechazo: {}
    };
  },
  methods: {
    async onShow() {
      try {
        const response = await this.$axios.get("/api/v1/bluefields/rechazo/" + this.item.id + "/");
        this.rechazo = response.data;
      } catch (error) {
        this.$bvToast.toast("Error al obtener el detalle del rechazo", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      } finally {
        this.ready = true;
      }
    },
    onHide() {
      this.rechazo = null;
      this.ready = false;
    }
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style></style>
